import { I18n } from 'react-redux-i18n';

export const permissionsInit = {
  user_client_bol_permission_cart: false,
  sphere: false,
  email: false,
  user_client_bol_permission_spot: false,
  user_client_bol_permission_client_code: false,
  user_client_bol_permission_price: false,
  user_client_bol_permission_cross_selling: false,
  user_client_bol_permission_lead_time: false,
  user_client_bol_permission_stock: false,
  user_client_bol_permission_visualize_all_orders: false,
  user_client_bol_permission_similarity: false,
  user_client_bol_permission_purchase_estimate: false,
  user_client_bol_permission_purchase_billing: false,
  user_client_bol_permission_purchase_bank_slip: false,
  user_client_bol_permission_purchase_debit: false,
  user_client_bol_permission_purchase_credit: false,
  purchase: false,
  user_client_bol_permission_cart_users: false,
  user_client_bol_permission_opic_code: true,
  user_client_bol_permission_sonepar_code: true,
  firstApproved: false,
  secondApproved: false,
  user_client_bol_permission_purchase_payment_gateway: false,
  user_client_bol_permission_allow_mixed_purchase: false,
};

export const enumPermissions = {
  CART: 'user_client_bol_permission_cart',
  EMAIL: 'email',
  SPHERE: 'sphere',
  SPOT: 'user_client_bol_permission_spot',
  CLIENT_CODE: 'user_client_bol_permission_client_code',
  PRICE: 'user_client_bol_permission_price',
  CROSS_SELLING: 'user_client_bol_permission_cross_selling',
  LEAD_TIME: 'user_client_bol_permission_lead_time',
  STOCK: 'user_client_bol_permission_stock',
  PANEL: 'user_client_bol_permission_visualize_all_orders',
  SIMILARITY: 'user_client_bol_permission_similarity',
  PURCHASE_ESTIMATE: 'user_client_bol_permission_purchase_estimate',
  PURCHASE_BILLING: 'user_client_bol_permission_purchase_billing',
  PURCHASE_BANK_SLIP: 'user_client_bol_permission_purchase_bank_slip',
  PURCHASE_DEBIT: 'user_client_bol_permission_purchase_debit',
  PURCHASE_CREDIT: 'user_client_bol_permission_purchase_credit',
  PURCHASE: 'purchase',
  CART_USERS: 'user_client_bol_permission_cart_users',
  OPIC_CODE: 'user_client_bol_permission_opic_code',
  SONEPAR_CODE: 'user_client_bol_permission_sonepar_code',
  VISUALIZE_ALL_ORDERS: 'user_client_bol_permission_visualize_all_orders',
  FIRST_APPROVED: 'firstApproved',
  SECOND_APPROVED: 'secondApproved',
  PURCHASE_PAYMENT_GATEWAY: 'user_client_bol_permission_purchase_payment_gateway',
  ALLOW_MIXED_PURCHASE: 'allowMixedPurchase',
};

export const config = [
  {
    name: I18n.t('visualization'),
    permissions: [
      {
        id: 'user_client_bol_permission_similarity',
        label: 'visualizeSimilarity',
      },
      {
        id: 'user_client_bol_permission_cross_selling',
        label: 'visualizeCrossselling',
      },
      {
        id: 'user_client_bol_permission_stock',
        label: 'visualizeStock',
      },
      {
        id: 'user_client_bol_permission_lead_time',
        label: 'visualizeLeadtime',
      },
      {
        id: 'user_client_bol_permission_opic_code',
        label: 'visualizeOpicCode',
      },
      {
        id: 'user_client_bol_permission_sonepar_code',
        label: 'visualizeSoneparCode',
      },
    ],
  },
  {
    name: I18n.t('products'),
    permissions: [
      {
        id: 'user_client_bol_permission_price',
        label: 'visualizePrice',
      },
      {
        id: 'user_client_bol_permission_spot',
        label: 'visualizeSpot',
      },
    ],
  },
  {
    name: I18n.t('cart'),
    permissions: [
      {
        id: 'user_client_bol_permission_cart',
        label: 'visualizeCart', // acesso ao carrinho
      },
      {
        id: 'user_client_bol_permission_client_code',
        label: 'visualizeClientCode',
      },
      {
        id: 'user_client_bol_permission_cart_users',
        label: 'cartUser',
      },
      {
        id: 'user_client_bol_permission_purchase_estimate',
        label: 'generateEstimate',
      },
      {
        id: 'allowMixedPurchase',
        label: 'allowMixedPurchase',
      },
    ],
  },
  {
    name: I18n.t('payment'),
    permissions: [
      {
        id: 'user_client_bol_permission_purchase_credit',
        label: 'finalizePurchaseCredit',
      },
      {
        id: 'user_client_bol_permission_purchase_debit',
        label: 'finalizePurchaseDebit',
      },
      {
        id: 'user_client_bol_permission_purchase_bank_slip',
        label: 'finalizePurchaseBankSlip',
      },
      {
        id: 'user_client_bol_permission_purchase_billing',
        label: 'finalizePurchaseBilling',
      },
      {
        id: 'user_client_bol_permission_purchase_payment_gateway',
        label: 'finalizePurchasePaymentGateway',
      },
    ],
  },
  {
    name: 'Painel',
    permissions: [
      {
        id: 'user_client_bol_permission_visualize_all_orders',
        label: 'visualizeAllOrders',
      },
    ],
  },
];

export default {
  permissionsInit,
  config,
};
